import { render, staticRenderFns } from "./CompetitionDetail.vue?vue&type=template&id=1d512703&scoped=true"
import script from "./CompetitionDetail.vue?vue&type=script&lang=js"
export * from "./CompetitionDetail.vue?vue&type=script&lang=js"
import style0 from "./CompetitionDetail.vue?vue&type=style&index=0&id=1d512703&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d512703",
  null
  
)

export default component.exports